(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/views/pages/play-single-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/views/pages/play-single-page.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const _productMapping$CONST = productMapping.CONSTANTS,
  EUROJACKPOT_TUESDAY = _productMapping$CONST.EUROJACKPOT_TUESDAY,
  EUROJACKPOT_FRIDAY = _productMapping$CONST.EUROJACKPOT_FRIDAY;
svs.eurojackpot.views.PlaySinglePage = Marionette.View.extend({
  viewOptions: ['showDrawCount', 'showAccountSelector'],
  showDrawCount: true,
  showAccountSelector: true,
  regions: {
    ngRowsContainerRegion: '#ngRowsContainerRegion',
    ngBetslipRegion: '#ngBetslipRegion',
    ngPayfooterRegion: '#ngPayfooterRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'eurojackpot',
    component: 'play'
  }],
  template(data) {
    return svs.eurojackpot.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.eurojackpot.components.play) {
      const isTargetB = svs.components.targeting.isTargeted('COT_Spelarvyn_ForvaldaDragningsdagar', 'B');
      const isSelfService = svs.core.config.data.svsconfig.isSelfService;
      const numberOfBoards = svs.core.detect.formfactor.desktop() ? svs.numbergames.rules.EUROJACKPOT.maxNumberOfRows : 1;
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: productMapping.CONSTANTS.EUROJACKPOT,
        selectedDays: isTargetB ? [svs.numbergames.game.draw.upcomingDrawProduct] : [EUROJACKPOT_TUESDAY, EUROJACKPOT_FRIDAY],
        boards: numberOfBoards
      }, {
        storageKey: 'single',
        noEmptyBoards: !isSelfService,
        parse: true,
        rules: svs.numbergames.rules.getRules({
          productId: svs.numbergames.productMapping.CONSTANTS.EUROJACKPOT
        }),
        hasTickets: svs.eurojackpot.data.hasTickets
      });
      if (!isSelfService) {
        const boards = model.get('boards');
        const invalidBoards = boards.where({
          isEmpty: false,
          isValid: false
        });
        if (invalidBoards.length) {
          svs.eurojackpot.logger.info("Wager model initialized with ".concat(invalidBoards.length, " invalid boards"));
          invalidBoards.forEach(board => board.destroy());
          if (numberOfBoards > boards.size()) {
            boards.add(numberOfBoards - boards.size());
          }
        }
      }
      this.showChildView('ngRowsContainerRegion', new svs.eurojackpot.components.play.views.SingleRowsContainer({
        model
      }));
      this.showChildView('ngBetslipRegion', new svs.eurojackpot.components.play.views.Betslip({
        model,
        showDrawCount: this.showDrawCount,
        showAccountSelector: this.showAccountSelector
      }));
      this.showChildView('ngPayfooterRegion', new svs.eurojackpot.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);